import React from 'react'
import 'react-tabs/style/react-tabs.css';
import db from './db';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import FacilityPopup from './FacilityPopup.js';
import HubPopup from "./HubPopup";
import Popup from './Popup.js';

export default class GenerateHubRecords extends React.Component {

    constructor(props) {
        super(props);
        let query=props.securityObject.httpServer + `api/get/hubForGeneratHubNo?facility_name=Board Inventory&facility_id=${FacilityPopup.boardInventoryFacilityId}`;
        let columns=[
                { key:'facility_id',title:'Facility id',width:20, noquery:true},
                { key:'facility_name',title:'Facility Name',width:20, noquery:true},
                { key: 'hostname', title:"Hostname", width :40 },
                { key: 'display_name', title:"Name", width :40 }
                ];
        this.state = {
            visible : false,
            columns:columns,
            boardInventoryHubs:[],
            query:query,
            hub:{},
            hubVisible:false,
            recordsToGenerateDisplayString:"",
            hostnameArr:[],
            addBoardsVisible:false
            //,tableRef:React.createRef()
        }
        this.tableRefDisplay1=React.createRef();
        this.tableRefAdd2=React.createRef();
        this.prefixInputRef=React.createRef();
        this.startInputRef=React.createRef();
        this.icb_version=React.createRef();
        this.number_of_batteries=React.createRef();
        this.model=React.createRef();
        this.numberToGenerateInputRef=React.createRef();
    }    
    componentDidMount(prevProps) {
        this.updateBoardInventoryList();
    }
    componentDidUpdate(prevProps) {
        //this.updateBoardInventoryList();
     }
    
    // render
    render() {
        let objectDate = new Date();
        let month = objectDate.getMonth()+1;
        let year = objectDate.getFullYear()-2000;

        let monthYear=`${year}`
        if(month<10){
            monthYear+="0";
        }
        monthYear+=month;

        return(true) ? (
            <div>
                <h4>
                    Current Boards in Inventory&nbsp;&nbsp;
                    <button onClick={()=>this.openAddBoardsPopup()}>Add Boards</button>&nbsp;&nbsp;
                    <button onClick={()=>{this.exportHubLabelCsv()}} >Export Labels CSV</button>
                </h4>
                <TableScrollbar  height="70vh">
                    <ErrorBoundary>
                        <Table columns={[
                                    { key: 'id', title:"ID", width :10 } 
                                    , { key: 'hostname', title:"Host Name", width :20 }
                                    , { key: 'name', title:"Name", width :20 }
                                    , { key: 'model', title:"Model", width :10 }
                                    , { key: 'icb_Number', title:"icb_Number", width :10}
                                    , { key: 'icb_version', title:"icb_version", width :10 }
                                    , { key: 'icb_date_shipped', title:"icb_date_shipped", width :10 }
                                    , { key: 'number_of_batteries', title:"Batteries", width :20 }
                                ]} 
                                dataSource={this.state.boardInventoryHubs} 
                                onRowClick={this.editThisHub.bind(this)} 
                                />
                    </ErrorBoundary>
                </TableScrollbar>                        

                <Popup trigger={this.state.addBoardsVisible}>
                <div className="align-right">
                        <button className="" onClick={() => this.closeAddBoardsPopup() }>x</button>
                    </div>
                    <h4>Add Board (Boards Created in batch)</h4>
                    <button onClick={()=>this.addHubs(`hub`,'w2000','4')}>Add dps(hub)</button>&nbsp;
                    <button onClick={()=>this.addHubs(`lea${monthYear}`,'lea','2')}>Add lea</button>&nbsp;
                    <table>
                        <tr>
                            <td>
                                Hostname Prefix:
                            </td>
                            <td>
                                <input id="prefixInput" ref={this.prefixInputRef} onChange={()=>this.updateList()}  style={ {width:70} } ></input>
                            </td>
                            <td>
                                Records To Generate
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Starting Number:
                            </td>
                            <td>
                                <input id="startInput" ref={this.startInputRef} onChange={()=>this.updateList()} type="number" defaultValue="1" style={ {width:70} } ></input>
                            </td>
                            <td rowspan="2">
                                {this.state.recordsToGenerateDisplayString}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Number to Generate:
                            </td>
                            <td>
                                <input id="numberToGenerateInput" ref={this.numberToGenerateInputRef} onChange={()=>this.updateList()} type="number" defaultValue="10" style={ {width:70} } ></input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Version:
                            </td>
                            <td>
                                <input id="icb_version" ref={this.icb_version}  defaultValue="1.0.0" style={ {width:70} } ></input>
                            </td>
                        </tr>                    
                        <tr>
                            <td>
                                Number of Batteries:
                            </td>
                            <td>
                                <input id="number_of_batteries" ref={this.number_of_batteries}  defaultValue="2" style={ {width:70} } ></input>
                            </td>
                        </tr>                    
                        <tr>
                            <td>
                                Model:
                            </td>
                            <td>
                                <input id="model" ref={this.model}  defaultValue="" style={ {width:70} } ></input>
                            </td>
                        </tr>                    
                    </table>
                    <button onClick={()=>this.generateBoards()}>Generate Records</button>
                </Popup>
                <HubPopup
                    hubId={this.state.hub.id}
                    visible={this.state.hubVisible}
                    securityObject={this.props.securityObject}
                    onCloseHubPopup={this.closeHubPopup.bind(this)}
                >
                </HubPopup>
            </div>
        ) :"";
    }
    addHubs(filter, model,numberOfBatteries){
        // set the filter
        //console.log(this.tableRefAdd2.current.state.refArray[0].value);
        //this.tableRefAdd2.current.setState({
        //    refArray:this.tableRefAdd2.current.state.refArray
        //},this.tableRefAdd2.current.queryData()
        //);
        db.getMaxHub(filter,this.props.securityObject, (data)=>{
            let nextNo=1;
            try{
                if(data[0].max_hostname){
                    nextNo=data[0].max_hostname.substring(filter.length);
                    nextNo=parseInt(nextNo)+1;
                }
            } catch (ex){
                alert(ex);
            }
            //alert(JSON.stringify(data));
            //alert(nextNo);
            this.startInputRef.current.value=nextNo;
            this.prefixInputRef.current.value=filter;
            this.number_of_batteries.current.value=numberOfBatteries;
            this.model.current.value=model;
            this.updateList();    
        });
    }
    updateList(){
        let prefixValue=this.prefixInputRef.current.value;
        let startValue=parseInt(this.startInputRef.current.value);
        let numberToGenerateValue=parseInt(this.numberToGenerateInputRef.current.value);
        let string="";
        let fail=false;
        let hostnameArr=[];
        for(let i=startValue;i<(numberToGenerateValue+startValue);i++){
            let hostname=prefixValue+i;
            if(i<10){
                hostname=prefixValue+"0"+i;
            }
            if(hostname.length<=9){
                string+=hostname+", ";
                hostnameArr.push(hostname);
                this.setState({hostnameArr})
            } else {
                fail=true;
            }
        }
        this.setState({recordsToGenerateDisplayString:string});
        if(fail){
            alert("host names can not be more than 9 characters")
        }

    }
    generateBoards(){
        if(this.state.hostnameArr.length>0){
            if(window.confirm("Are you sure you want to Generate these records?")){
                let data={
                    hostnames:this.state.hostnameArr
                    ,icb_version: this.icb_version.current.value
                    ,number_of_batteries: this.number_of_batteries.current.value
                    ,model: this.model.current.value
                };
                let thisThis=this;
                db.saveData( this.props.securityObject
                    , data
                    ,"api/generateHubs"
                    , function(res){
                        thisThis.updateBoardInventoryList();
                        thisThis.prefixInputRef.current.value="";
                        this.setState({recordsToGenerateDisplayString:""});
                        thisThis.updateList();
                        }
                );
            }
        }
    }
    // edit a hub
    editThisHub( rowData, rowIndex ){
        this.setState({
            hub:rowData
            , hubVisible:true
        })
    }
    updateBoardInventoryList(){
        db.getHubs( 
            ""
            ,""
            ,""
            ,FacilityPopup.boardInventoryFacilityId
            ,this.props.securityObject
            ,(hubList) => { 
                this.setState({
                    boardInventoryHubs : hubList,
                    hostnameArr:[]
                })
            }
        )
    }

    closeHubPopup(){
        this.setState({
            hubVisible:false
        })
        this.updateBoardInventoryList();
    }

    exportHubLabelCsv(params){
        let url=this.props.securityObject.httpServer
                +"api/get/hubForLabels?sessionId="
                +this.props.securityObject.userSessionId;
        url+=`&facility_id=${FacilityPopup.boardInventoryFacilityId}`;
        window.open(url);
    }
    openAddBoardsPopup(){
        this.setState({
            addBoardsVisible:true
        });
    }
    closeAddBoardsPopup(rowData){
        this.setState({
            addBoardsVisible:false
        });
    }

}

